<template>
  <v-card rounded="0" height="90%" flat>
    <!-- Ticket Code -->
    <v-row no-gutters justify="center">
      <v-col cols="12">
        <div class="text-center codeText">{{ ticket.code }}</div>
      </v-col>
    </v-row>

    <!-- Ticket Counter Info -->
    <v-row no-gutters>
      <v-col cols="12">
        <div class="text-center counterText">{{ window_name.lang }}</div>
        <div class="text-center counterText">{{ window_name.english }}</div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TicketCard',
  props: {
    ticket: {
      type: Object
    }
  },
  computed: {
    ...mapState(['socket']),
    window_list() {
      return this.socket.window_list
    },
    window_name() {
      const target_window = this.window_list.find(window => window.window_id === this.ticket.window_id)
      if (this.ticket.language === 'Mandarin') return { lang: target_window.name_cn, english: target_window.name_en }
      else return { lang: target_window.name, english: target_window.name_en }
    }
  }
}
</script>

<style scoped>
.codeText {
  margin-top: 1.5rem;
  font-size: 4rem;
  color: #d31145;
  letter-spacing: 4px;
}

.counterText {
  font-size: 2rem;
  color: #e4708f;
  letter-spacing: 2px;
}

@media only screen and (max-width: 960px) {
  .codeText {
    font-size: 2rem;
    margin-top: 0.5rem;
  }

  .counterText {
    font-size: 1rem;
  }
}
</style>
